<script>
import { mapActions, mapGetters } from 'vuex'
import FILTRO_EMPTY from '@/models/filtro'
import PermissaoHelper from '../../PermissaoHelper'
import statusProcesso from '@/utils/status'
import perfisMa from '@/utils/ma/perfis'
const { setores } = require('@/utils/ma/setor').default

export default {

  async created () {
    this.getPermissoes()
    this.usuario = await this.getUsuario()
  },

  mixins: [
    PermissaoHelper
  ],

  data () {
    return {
      statusAguardandoAnalise: [
        statusProcesso.AGUARDANDO_ANALISE,
        statusProcesso.AGUARDANDO_ANALISE_DOCUMENTAL,
        statusProcesso.AGUARDANDO_ANALISE_VISTORIA,
        statusProcesso.AGUARDANDO_ANALISE_DISTRIBUICAO,
        statusProcesso.AGUARDANDO_ANALISE_GEO,
        statusProcesso.AGUARDANDO_ANALISE_VALIDACAO_GEO,
        statusProcesso.AGUARDANDO_ANALISE_VERIFICACAO_GEO,
        statusProcesso.AGUARDANDO_ANALISE_PORTARIA,
        statusProcesso.AGUARDANDO_ENTREGA_TITULO,
        statusProcesso.AGUARDANDO_ANALISE_FINAL,
        statusProcesso.AGUARDANDO_ANALISE_PESQUISA_SPU,
        statusProcesso.AGUARDANDO_ARQUIVAMENTO,
        statusProcesso.AGUARDANDO_ANALISE_RELATORIO,
        statusProcesso.AGUARDANDO_ANALISE_REUNIAO_MOBILIZACAO,
        statusProcesso.AGUARDANDO_ANALISE_PRELIMINAR_GEO,
        statusProcesso.AGUARDANDO_PUBLICACAO_EDITAL,
        statusProcesso.AGUARDANDO_ANALISE_PGE,
        statusProcesso.AGUARDANDO_DECISAO_FINAL,
        statusProcesso.AGUARDANDO_ANALISE_CASA_CIVIL,
        statusProcesso.AGUARDANDO_ANALISE_PDS,
        statusProcesso.AGUARDANDO_ANALISE_INCRA,
        statusProcesso.AGUARDANDO_ANALISE_GERENCIAMENTO_BENEFICIARIOS,
        statusProcesso.AGUARDANDO_ANALISE_PENDENCIAS,
        statusProcesso.AGUARDANDO_ANALISE_GERENCIAMENTO_CREDITOS,
        statusProcesso.AGUARDANDO_DECISAO,
        statusProcesso.AGUARDANDO_ANALISE_DRF,
        statusProcesso.AGUARDANDO_ANALISE_URBANISTICO,
        statusProcesso.AGUARDANDO_FINALIZACAO,
        statusProcesso.AGUARDANDO_ANALISE_RESPOSTA_SPU,
        statusProcesso.AGUARDANDO_ANALISE_MALHA_FUNDIARIA,
        statusProcesso.EM_ANALISE_MALHA_FUNDIARIA,
        statusProcesso.AGUARDANDO_PARECER_INDEFERIMENTO,
        statusProcesso.AGUARDANDO_ARQUIVAMENTO_INDEFERIMENTO,
        statusProcesso.AGUARDANDO_ANALISE_DESARQUIVAMENTO,
        statusProcesso.AGUARDANDO_PARECER_DESARQUIVAMENTO
      ],
      statusEmAnalise: [
        statusProcesso.EM_ANALISE,
        statusProcesso.EM_ANALISE_GEO,
        statusProcesso.EM_ANALISE_VALIDACAO_GEO,
        statusProcesso.EM_ANALISE_VISTORIA,
        statusProcesso.EM_ANALISE_PORTARIA,
        statusProcesso.EM_ANALISE_PESQUISA_SPU,
        statusProcesso.EM_ARQUIVAMENTO,
        statusProcesso.EM_ENTREGA_TITULO,
        statusProcesso.EM_ANALISE_RELATORIO,
        statusProcesso.EM_ANALISE_REUNIAO_MOBILIZACAO,
        statusProcesso.EM_ANALISE_PRELIMINAR_GEO,
        statusProcesso.EM_PUBLICACAO_EDITAL,
        statusProcesso.EM_ANALISE_PGE,
        statusProcesso.EM_DECISAO_FINAL,
        statusProcesso.EM_ANALISE_CASA_CIVIL,
        statusProcesso.EM_ANALISE_PDS,
        statusProcesso.EM_ANALISE_INCRA,
        statusProcesso.EM_ANALISE_GERENCIAMENTO_BENEFICIARIOS,
        statusProcesso.EM_ANALISE_PENDENCIAS,
        statusProcesso.EM_ANALISE_GERENCIAMENTO_CREDITOS,
        statusProcesso.EM_ANALISE_DRF,
        statusProcesso.EM_ANALISE_URBANISTICO,
        statusProcesso.EM_FINALIZACAO,
        statusProcesso.EM_ANALISE_RESPOSTA_SPU,
        statusProcesso.EM_ARQUIVAMENTO_INDEFERIMENTO,
        statusProcesso.EM_ANALISE_PARECER_INDEFERIMENTO,
        statusProcesso.EM_ANALISE_DESARQUIVAMENTO,
        statusProcesso.EM_ANALISE_PARECER_DESARQUIVAMENTO
      ],
      statusAguardandoValidacao: [
        statusProcesso.AGUARDANDO_VALIDACAO_ANALISE,
        statusProcesso.AGUARDANDO_VALIDACAO,
        statusProcesso.AGUARDANDO_VALIDACAO_DISTRIBUICAO,
        statusProcesso.AGUARDANDO_VALIDACAO_DOCUMENTAL,
        statusProcesso.AGUARDANDO_VALIDACAO_VISTORIA,
        statusProcesso.AGUARDANDO_VALIDACAO_VALIDACAO_GEO,
        statusProcesso.AGUARDANDO_VALIDACAO_GEO,
        statusProcesso.AGUARDANDO_VALIDACAO_PORTARIA,
        statusProcesso.AGUARDANDO_VALIDACAO_FINAL,
        statusProcesso.AGUARDANDO_VALIDACAO_PESQUISA_SPU,
        statusProcesso.AGUARDANDO_VALIDACAO_ARQUIVAMENTO,
        statusProcesso.AGUARDANDO_VALIDACAO_ENTREGA_TITULO,
        statusProcesso.AGUARDANDO_VALIDACAO_RELATORIO,
        statusProcesso.AGUARDANDO_VALIDACAO_PRELIMINAR_GEO,
        statusProcesso.AGUARDANDO_VALIDACAO_PUBLICACAO_EDITAL,
        statusProcesso.AGUARDANDO_VALIDACAO_DECISAO_FINAL,
        statusProcesso.AGUARDANDO_VALIDACAO_ANALISE_PGE,
        statusProcesso.AGUARDANDO_VALIDACAO_CASA_CIVIL,
        statusProcesso.AGUARDANDO_VALIDACAO_PDS,
        statusProcesso.AGUARDANDO_VALIDACAO_INCRA,
        statusProcesso.AGUARDANDO_VALIDACAO_GERENCIAMENTO_BENEFICIARIOS,
        statusProcesso.AGUARDANDO_VALIDACAO_PENDENCIAS,
        statusProcesso.AGUARDANDO_VALIDACAO_GERENCIAMENTO_CREDITOS,
        statusProcesso.AGUARDANDO_VALIDACAO_DRF,
        statusProcesso.AGUARDANDO_VALIDACAO_URBANISTICO,
        statusProcesso.AGUARDANDO_VALIDACAO_RESPOSTA_SPU,
        statusProcesso.AGUARDANDO_VALIDACAO_PARECER_INDEFERIMENTO,
        statusProcesso.AGUARDANDO_VALIDACAO_ARQUIVAMENTO_INDEFERIMENTO,
        statusProcesso.AGUARDANDO_VALIDACAO_DESARQUIVAMENTO,
        statusProcesso.AGUARDANDO_VALIDACAO_PARECER_DESARQUIVAMENTO
      ],
      statusEmRevisao: [
        statusProcesso.EM_REVISAO,
        statusProcesso.EM_REVISAO_BASE,
        statusProcesso.EM_REVISAO_DOCUMENTAL,
        statusProcesso.EM_REVISAO_GEO,
        statusProcesso.EM_REVISAO_VALIDACAO_GEO,
        statusProcesso.EM_REVISAO_VISTORIA,
        statusProcesso.EM_REVISAO_PORTARIA,
        statusProcesso.EM_REVISAO_PESQUISA_SPU,
        statusProcesso.EM_REVISAO_ANALISE_PORTARIA,
        statusProcesso.EM_REVISAO_FINAL,
        statusProcesso.EM_REVISAO_ARQUIVAMENTO,
        statusProcesso.EM_REVISAO_ENTREGA_TITULO,
        statusProcesso.EM_REVISAO_RELATORIO,
        statusProcesso.EM_REVISAO_PRELIMINAR_GEO,
        statusProcesso.EM_REVISAO_PUBLICACAO_EDITAL,
        statusProcesso.EM_REVISAO_ANALISE_PGE,
        statusProcesso.EM_REVISAO_DECISAO_FINAL,
        statusProcesso.EM_REVISAO_CASA_CIVIL,
        statusProcesso.EM_REVISAO_INCRA,
        statusProcesso.EM_REVISAO_PDS,
        statusProcesso.EM_REVISAO_GERENCIAMENTO_BENEFICIARIOS,
        statusProcesso.EM_REVISAO_PENDENCIAS,
        statusProcesso.EM_REVISAO_GERENCIAMENTO_CREDITOS,
        statusProcesso.EM_REVISAO_DRF,
        statusProcesso.EM_REVISAO_URBANISTICO,
        statusProcesso.EM_REVISAO_FINALIZACAO,
        statusProcesso.EM_REVISAO_ARQUIVAMENTO_INDEFERIMENTO,
        statusProcesso.EM_REVISAO_INDEFERIMENTO,
        statusProcesso.EM_REVISAO_RESPOSTA_SPU,
        statusProcesso.EM_REVISAO_DESARQUIVAMENTO,
        statusProcesso.EM_REVISAO_PARECER_DESARQUIVAMENTO
      ],
      statusDecisao: [
        statusProcesso.AGUARDANDO_DECISAO,
        statusProcesso.EM_DECISAO
      ],
      exibirSemResponsavel: [
        statusProcesso.EM_ANALISE,
        statusProcesso.EM_ANALISE_MALHA_FUNDIARIA,
        statusProcesso.EM_ANALISE_FINAL,
        statusProcesso.EM_ANALISE_GEO,
        statusProcesso.EM_ANALISE_DOCUMENTAL,
        statusProcesso.EM_ANALISE_VISTORIA,
        statusProcesso.EM_ANALISE_VALIDACAO_GEO,
        statusProcesso.EM_ARQUIVAMENTO,
        statusProcesso.EM_ANALISE_URBANISTICO
      ],
      usuario: null
    }
  },

  methods: {
    ...mapActions({
      getProcessos: 'processo/getProcessos',
      getInformacoes: 'informacao/getInformacoes',
      getOrdensServicos: 'ordemServico/getOrdemServico',
      getSubProcessos: 'subProcesso/getProcessos',
      getProcessoByOrdemServico: 'ordemServico/getProcessoByOrdemServico',
      getPermissoes: 'auth/setPermissoes',
      setProcessoSelecionados: 'ordemServico/setProcessoSelecionados',
      tramitar: 'processo/tramitar',
      finalizarImpressaoTitulo: 'despacho/finalizarImpressaoTitulo',
      tramitarByPerfil: 'processo/tramitarByPerfil'
    }),
    ...mapGetters({
      getUsuario: 'auth/usuarioLogado'
    }),
    async init (callback) {
      const data = await this.buscar()
      if (callback) data.content = callback(data.content)
      this.items = data.content || data.processos.content
      this.totalElements = data.totalElements || data.processos?.totalElements
      this.setorSelecionado = this.usuario.perfilSelecionado ? this.usuario.perfilSelecionado.setor.codigo : null
      if (data.processos) {
        this.infoPrazos = {
          totalVencidos: data.totalVencidos,
          totalAVencer: data.totalAVencer,
          totalEmDia: data.totalEmDia
        }
      }
    },
    converterParaDate (dataString) {
      let [dia, mes, ano] = dataString.split('/')
      return new Date(`${ano}-${mes}-${dia}`)
    },
    async initInformacoes () {
      const data = await this.buscar()
      this.items = data.content || data.processos.content
      this.totalElements = data.totalElements || data.processos?.totalElements
      if (data.processos) {
        this.infoPrazos = {
          totalVencidos: data.totalVencidos,
          totalAVencer: data.totalAVencer,
          totalEmDia: data.totalEmDia
        }
      }
    },
    async initOrdemServico () {
      const data = await this.buscar()
      this.items = data.content || data.processos.content
      this.totalElements = data.totalElements || data.processos?.totalElements
    },
    async initProcessosOrdemServico () {
      const data = await this.buscar()
      this.items = data.content || data.processos.content
      this.processosSelecionados = data.processosSelecionados
      this.totalElements = data.totalElements || data.processos?.totalElements
      if (data.processos) {
        this.infoPrazos = {
          totalVencidos: data.totalVencidos,
          totalAVencer: data.totalAVencer,
          totalEmDia: data.totalEmDia
        }
      }
    },
    async initSubProcessos () {
      const data = await this.buscar()
      this.items = data.content || data.processos.content
      this.totalElements = data.totalElements || data.processos?.totalElements
      if (data.processos) {
        this.infoPrazos = {
          totalVencidos: data.totalVencidos,
          totalAVencer: data.totalAVencer,
          totalEmDia: data.totalEmDia
        }
      }
    },
    selecionaProcesso (item) {
      item.selecionado = !item.selecionado
      this.setProcessoSelecionados({ processos: _.cloneDeep(this.items.filter(i => i.selecionado)) || [], map: true }) //eslint-disable-line
    },
    async pesquisar (filtro) {
      this.filtro = { ...filtro, pagina: 0, caixa: this.filtro.caixa }
      const data = await this.buscar()
      this.items = data.content || data.processos.content
      this.checkProcessosSelecionados()
      this.totalElements = data.totalElements || data.processos?.totalElements
      if (data.processos) {
        this.infoPrazos = {
          totalVencidos: data.totalVencidos,
          totalAVencer: data.totalAVencer,
          totalEmDia: data.totalEmDia
        }
      }
    },
    async filtroComColunasExibidas () {
      this.filtro = { ...this.filtro }
    },
    async pesquisarInformacoes (filtro) {
      this.filtro = { ...filtro, pagina: 0, caixa: this.filtro.caixa }
      const data = await this.buscar()
      this.items = data.content || data.processos.content
      this.totalElements = data.totalElements || data.processos?.totalElements
      if (data.processos) {
        this.infoPrazos = {
          totalVencidos: data.totalVencidos,
          totalAVencer: data.totalAVencer,
          totalEmDia: data.totalEmDia
        }
      }
    },
    async pesquisarOrdemServico (filtro) {
      this.filtro = { ...filtro, pagina: 0, caixa: this.filtro.caixa }
      const data = await this.buscar()
      this.items = data.content || data.processos.content
      this.totalElements = data.totalElements
      if (data.processos) {
        this.infoPrazos = {
          totalVencidos: data.totalVencidos,
          totalAVencer: data.totalAVencer,
          totalEmDia: data.totalEmDia
        }
      }
    },
    executar (item) {
      this[item.acao](this, item)
    },
    async changePage (newPage) {
      this.filtro.pagina = newPage - 1
      const data = await this.buscar()
      this.items = data.content || data.processos.content
      this.checkProcessosSelecionados()
      this.totalElements = data.totalElements || data.processos?.totalElements
      if (data.processos) {
        this.infoPrazos = {
          totalVencidos: data.totalVencidos,
          totalAVencer: data.totalAVencer,
          totalEmDia: data.totalEmDia
        }
      }
    },
    async sort (item) {
      this.filtro.ordem = item.ordem
      this.filtro.ordemDirecao = item.tipo
      const data = await this.buscar()
      this.items = data.content || data.processos.content
      this.totalElements = data.totalElements || data.processos?.totalElements
      if (data.processos) {
        this.infoPrazos = {
          totalVencidos: data.totalVencidos,
          totalAVencer: data.totalAVencer,
          totalEmDia: data.totalEmDia
        }
      }
    },
    async buscar () {
      switch (this.filtro.caixa) {
        case 'INFORMACAO_SOLICITADA':
          return this.getInformacoes({ dados: { ...this.filtro } })
        case 'ORDEM_SERVICO':
          return this.getOrdensServicos({ dados: { ...this.filtro } })
        case 'LISTAGEM_PROCESSO_ORDEM_SERVICO': {
          this.filtro.numeroOs = this.numero
          this.loading = true
          const processos = await this.getProcessoByOrdemServico({ dados: { ...this.filtro } })
          this.loading = false
          return processos
        }
        case 'CAIXA_ENTRADA_OS':
        case 'EM_ANALISE_OS':
          return this.getSubProcessos({ dados: { ...this.filtro } })
        default:
          return this.getProcessos({ dados: { ...this.filtro } })
      }
    },
    async clear (item) {
      this.filtro = FILTRO_EMPTY(this.filtro.caixa)
      this.filtro.pagina = 0
      const data = await this.buscar()
      this.items = data.content || data.processos.content
      this.checkProcessosSelecionados()
      this.totalElements = data.totalElements || data.processos?.totalElements
      if (data.processos) {
        this.infoPrazos = {
          totalVencidos: data.totalVencidos,
          totalAVencer: data.totalAVencer,
          totalEmDia: data.totalEmDia
        }
      }
    },
    async clearInformacoes (item) {
      this.filtro = FILTRO_EMPTY(this.filtro.caixa)
      this.filtro.pagina = 0
      const data = await this.buscar()
      this.items = data.content || data.processos.content
      this.totalElements = data.totalElements || data.processos?.totalElements
    },
    checkProcessosSelecionados () {
      if (this.filtro.caixa === 'LISTAGEM_PROCESSO_ORDEM_SERVICO') {
        this.processosSelecionados.forEach((processoSelecionado) => {
          this.items = this.items.map((item) => {
            if (processoSelecionado.id === item.id) {
              item.selecionado = true
              if (processoSelecionado.disabled) {
                item.disabled = true
              }
            }
            return item
          })
        })
      } else {
        this.items.forEach((processo) => {
          if (this.idsProcessos) {
            const idProcesso = this.idsProcessos.find(id => id === processo.id)
            if (idProcesso !== undefined) {
              processo.selecionado = true
            }
          }
        })
      }
    },
    async clearFiltroOrdemServico (item) {
      this.filtro = FILTRO_EMPTY(this.filtro.caixa)
      this.filtro.pagina = 0
      const data = await this.buscar()
      this.items = data.content || data.processos.content
      this.totalElements = data.totalElements || data.processos?.totalElements
    },
    async refresh (item) {
      if (item) {
        item.pagina = 0
      }
      const data = item ? await this.getProcessos({ dados: item }) : await this.buscar()
      this.items = data.content || data.processos.content
      this.totalElements = data.totalElements || data.processos?.totalElements
      if (data.processos) {
        this.infoPrazos = {
          totalVencidos: data.totalVencidos,
          totalAVencer: data.totalAVencer,
          totalEmDia: data.totalEmDia
        }
      }
    },
    async refreshInformacoes (item) {
      const data = await this.buscar()
      this.items = data.content || data.processos.content
      this.totalElements = data.totalElements || data.processos?.totalElements
      if (data.processos) {
        this.infoPrazos = {
          totalVencidos: data.totalVencidos,
          totalAVencer: data.totalAVencer,
          totalEmDia: data.totalEmDia
        }
      }
    },
    async refreshOrdemServico (item) {
      const data = await this.buscar()
      this.items = data.content || data.processos.content
      this.totalElements = data.totalElements || data.processos?.totalElements
      if (data.processos) {
        this.infoPrazos = {
          totalVencidos: data.totalVencidos,
          totalAVencer: data.totalAVencer,
          totalEmDia: data.totalEmDia
        }
      }
    },
    async executarTramitacao (processo) {
      await this.tramitar({ processo })
    },
    async executarTramitacaoImpressaoTitulo (processo) {
      return this.finalizarImpressaoTitulo(processo)
    },
    async executarTramitacaoByPerfil (processo) {
      await this.tramitarByPerfil({ processo })
    },
    isPerfilDatglPerfilSelecionado () {
      return [perfisMa.CHEFE_SETOR_DATGL, perfisMa.TECNICO_DATGL].includes(this.usuario.perfilSelecionado.codigo)
    },
    isPerfilChefeSetorDatgl () {
      return [perfisMa.CHEFE_SETOR_DATGL].includes(this.usuario.perfilSelecionado.codigo)
    },
    isAnalistaOuGestaoSicarf () {
      return [perfisMa.COMISSAO_GESTAO_SICARF, perfisMa.ANALISTA_CTRU].includes(this.usuario.perfilSelecionado.codigo)
    },
    isAnalistaCTRU () {
      return [perfisMa.ANALISTA_CTRU].includes(this.usuario.perfilSelecionado.codigo)
    },
    isVincularAnalista (processo) {
      const perfis = [
        perfisMa.DIRETOR_DRF,
        perfisMa.DIRETOR_DAF,
        perfisMa.COORDENADOR_CAF,
        perfisMa.CHEFE_SETOR_DF1,
        perfisMa.CHEFE_SETOR_DF3,
        perfisMa.CHEFE_SETOR_COMISSAO_ILHA,
        perfisMa.PROCURADOR_JURIDICO,
        perfisMa.CHEFE_SETOR_DATGL,
        perfisMa.PRESIDENTE_PRESIDENCIA,
        perfisMa.CHEFE_GABINETE_PRESIDENCIA,
        perfisMa.CHEFE_SETOR_CAS,
        perfisMa.COORDENADOR_CTT,
        perfisMa.DIRETOR_DADR,
        perfisMa.COORDENADOR_CEP,
        perfisMa.COORDENADOR_CADR,
        perfisMa.DIRETOR_DUF,
        perfisMa.AGENTE_ADMINISTRATIVO_PROTOCOLO,
        perfisMa.CHEFE_SETOR_GABINETE,
        perfisMa.ANALISTA_CTRU
      ]
      return this.usuario.perfilSelecionado ? perfis.includes(this.usuario.perfilSelecionado.codigo) : false
    },
    isAnalistaOrAtendentePerfilSelecionado () {
      return this.usuario.perfilSelecionado.codigo.includes('ATENDENTE') || this.usuario.perfilSelecionado.codigo.includes('ANALISTA')
    },
    isCoordanadorPerfilSelecionado () {
      return this.usuario.perfilSelecionado.codigo.includes('COORDENADOR')
    },
    isChefeSetorPerfilSelecionado () {
      return this.usuario.perfilSelecionado.codigo.includes('CHEFE_SETOR')
    },
    isTecnicoDatgl () {
      return this.usuario.perfilSelecionado.codigo.includes('TECNICO_DATGL')
    },
    isAnalistaOrAtendente (processo) {
      return processo.codigoPerfil.includes('ATENDENTE') || processo.codigoPerfil.includes('ANALISTA') || processo.codigoPerfil.includes('ADMINISTRATIVO') || processo.codigoPerfil.includes('ASSESSOR')
    },
    isResponsavelCoordenador (processo) {
      return processo.codigoPerfil.includes('COORDENADOR')
    },
    isResponsavelChefeSetor (processo) {
      return processo.codigoPerfil.includes('CHEFE_SETOR')
    },
    processoIsAguardandoAnalise (processo) {
      return this.statusAguardandoAnalise.includes(processo.codigoStatus)
    },
    processoIsEmAnalise (processo) {
      return this.statusEmAnalise.includes(processo.codigoStatus)
    },
    processoIsAguardandoTituloCertidao (processo) {
      return processo.codigoStatus === statusProcesso.AGUARDANDO_EMISSAO_TITULO
    },
    processoIsAguardandoEmissaoCertidao (processo) {
      return processo.codigoStatus === statusProcesso.AGUARDANDO_EMISSAO_CERTIDAO
    },
    processoIsAguardandoEmissaoTitulo (processo) {
      return processo.codigoStatus === statusProcesso.AGUARDANDO_EMISSAO_TITULO
    },
    processoIsAguardandoBoleto (processo) {
      return processo.codigoStatus === statusProcesso.AGUARDANDO_BOLETO
    },
    processoIsBoletoVencido (processo) {
      return processo.codigoStatus === statusProcesso.BOLETO_VENCIDO
    },
    processoIsAguardandoPortaria (processo) {
      return processo.codigoStatus === statusProcesso.AGUARDANDO_PORTARIA
    },
    processoIsEmEmissaoPortaria (processo) {
      return processo.codigoStatus === statusProcesso.EM_EMISSAO_PORTARIA
    },
    processoIsAguardandoPagamento (processo) {
      return processo.codigoStatus === statusProcesso.AGUARDANDO_PAGAMENTO || processo.parcelasQuitadas
    },
    processoIsAguardandoAcusarEntraga (processo) {
      return processo.codigoStatus === statusProcesso.AGUARDANDO_ENTREGA
    },
    isProcessoAcusandoPublicacao (processo) {
      return processo.codigoStatus === statusProcesso.ENVIADO_PARA_PUBLICACAO
    },
    showContinuarAtualizacaoBase (processo) {
      return false
    },
    showContinuarRevisaoBase (processo) {
      return false
    },
    showValidarBase (processo) {
      return false
    },
    processoIsAguardandoValidacao (processo) {
      return this.statusAguardandoValidacao.includes(processo.codigoStatus)
    },
    processoIsAguardandoPublicacao (processo) {
      return processo.codigoStatus === statusProcesso.AGUARDANDO_PUBLICACAO
    },
    processoIsAguardandoConferenciaTitulo (processo) {
      return processo.codigoStatus === statusProcesso.AGUARDANDO_CONFERENCIA_TITULO || processo.codigoStatus === statusProcesso.AGUARDANDO_VALIDACAO_TITULO
    },
    processoIsAguardandoConferenciaCertidao (processo) {
      return processo.codigoStatus === statusProcesso.AGUARDANDO_CONFERENCIA_CERTIDAO || processo.codigoStatus === statusProcesso.AGUARDANDO_VALIDACAO_CERTIDAO
    },
    processoIsEmEmissaoCertidao (processo) {
      return processo.codigoStatus === statusProcesso.EM_EMISSAO_CERTIDAO
    },
    processoIsEmEmissaoTitulo (processo) {
      return processo.codigoStatus === statusProcesso.EM_EMISSAO_TITULO
    },
    processoIsAguardandoAnaliseOs (processo) {
      return processo.statusOrdemServico === statusProcesso.AGUARDANDO_ANALISE
    },
    processoIsEmAnaliseOs (processo) {
      return processo.statusOrdemServico === statusProcesso.EM_ANALISE
    },
    isResponsavel (processo) {
      return processo.responsavel !== '--'
    },
    showContinuarEmissaoExtratoSentenca (processo) {
      return false
    },
    showContinuarConferenciaTitulo (processo) {
      return processo.codigoStatus === statusProcesso.EM_CONFERENCIA_TITULO && processo.idUsuario === this.usuario.id
    },
    showVisualizarExtratoSentenca (processo) {
      return false
    },
    showEmitirExtratoSentenca (processo) {
      return false
    },
    showEmitirCertidaoArea (processo) {
      return false
    },
    showTrocarResponsavel (processo) {
      return (this.hasPermissao(this.$permissao.TROCAR_ATENDENTE) ||
        this.hasPermissao(this.$permissao.VINCULAR_TROCAR_ANALISTA)) &&
        (processo.idUsuario !== null || this.exibirSemResponsavel.includes(processo.codigoStatus)) && !this.statusDecisao.includes(processo.codigoStatus)
    },
    showTrocaAnalistaLote () {
      return this.hasPermissao(this.$permissao.VINCULAR_TROCAR_ANALISTA) && !this.usuario.perfilSelecionado.codigo.includes('GESTOR_SICARF') && !this.usuario.perfilSelecionado.codigo.includes('PRESIDENTE_PRESIDENCIA')
    },
    showAnalisarProcesso (processo) {
      const usuarioDonoProcesso = processo.codigoPerfil.includes(this.usuario.perfilSelecionado.codigo.split('_')[0]) &&
        processo.idUsuario === this.usuario.id
      const processoSemDono = (this.usuario.perfilSelecionado.codigo.split('_')[0].includes(processo.codigoPerfil.split('_')[0]) ||
        processo.perfil === perfisMa.SISTEMA) &&
        (processo.idUsuario === null || processo.idUsuario === '')
      return (this.processoIsAguardandoAnalise(processo) && this.hasPermissao(this.$permissao.ANALISAR_PROCESSO) &&
        (usuarioDonoProcesso || processoSemDono)) || (this.processoIsAguardandoAnaliseOs(processo))
    },
    showAnalisarProcessoSemTramite (processo) {
      return false
    },
    showVincularAnalista (processo) {
      return this.hasPermissao(this.$permissao.VINCULAR_TROCAR_ANALISTA) && !this.isResponsavel(processo) && this.isVincularAnalista(processo) &&
       !this.statusDecisao.includes(processo.codigoStatus)
    },
    showVincularTrocarGerente (processo) {
      return this.hasPermissao(this.$permissao.VINCULAR_TROCAR_GERENTE) && this.isResponsavel(processo)
    },
    showAcusarPublicacao (processo) {
      return this.isProcessoAcusandoPublicacao(processo) && this.hasPermissao(this.$permissao.ACUSAR_PUBLICACAO)
    },
    showAcusarAssinatura (processo) {
      return this.hasPermissao(this.$permissao.ACUSAR_RECEBIMENTO)
    },
    showConfirmarEntrega (processo) {
      return this.hasPermissao(this.$permissao.CONFIRMAR_ENTREGA)
    },
    showAcusarEntrega (processo) {
      return this.processoIsAguardandoAcusarEntraga(processo) && this.hasPermissao(this.$permissao.ACUSAR_ENTREGA)
    },
    showRevisarBase (processo) {
      return processo.codigoStatus === statusProcesso.AGUARDANDO_REVISAO_BASE &&
        this.hasPermissao(this.$permissao.ATUALIZAR_BASE) && processo.idUsuario === this.usuario.id
    },
    showAtualizarBase (processo) {
      return this.hasPermissao(this.$permissao.ATUALIZAR_BASE)
    },
    showValidarAtualizacaoBase (processo) {
      return this.hasPermissao(this.$permissao.ATUALIZAR_BASE)
    },
    showAnalisarFinalizado (processo) {
      return this.hasPermissao(this.$permissao.ANALISAR_FINALIZADO)
    },
    showPublicarPortaria (processo) {
      return this.processoIsAguardandoPublicacao(processo) && this.hasPermissao(this.$permissao.PUBLICAR_PORTARIA)
    },
    showValidarProcesso (processo) {
      return this.processoIsAguardandoValidacao(processo) && this.hasPermissao(this.$permissao.VALIDAR_ANALISE)
    },
    showValidarOficio (processo) {
      return processo.codigoStatus === 'AGUARDANDO_VALIDACAO_OFICIO'
    },
    showValidarPortaria (processo) {
      return this.hasPermissao(this.$permissao.VALIDAR_PORTARIA)
    },
    showVisualizarProcesso (processo) {
      return true
    },
    showDesarquivarProcesso (processo) {
      let isDatgl = this.usuario.perfilSelecionado.codigo.includes('DATGL')
      let dataChegada = this.converterParaDate(processo.dataChegadaSetor)
      let dataLimite = this.converterParaDate('28/06/2024')
      let processosArquivadosNaoMigrados = dataChegada < dataLimite
      let setoresDesarquivamento = ['NAO_ONEROSO', 'ONEROSO', 'NAO_ONEROSO_FISICO', 'ONEROSO_FISICO']
      return isDatgl && setoresDesarquivamento.includes(processo.tipoCodigo) && processo.codigoStatus === statusProcesso.ARQUIVADO && !processosArquivadosNaoMigrados
    },
    showCancelarDaeDesarquivamento (processo) {
      return false
    },
    showEmitirPortaria (processo) {
      return this.processoIsAguardandoPortaria(processo) && this.hasPermissao(this.$permissao.CADASTRAR_PORTARIA) && (processo.idUsuario === this.usuario.id || processo.idUsuario === null)
    },
    showContinuarEmissaoPortaria (processo) {
      return this.processoIsEmEmissaoPortaria(processo) && this.hasPermissao(this.$permissao.CADASTRAR_PORTARIA) && processo.idUsuario === this.usuario.id
    },
    showEmitirDae (processo) {
      return (this.processoIsAguardandoBoleto(processo) || this.processoIsBoletoVencido(processo)) && this.hasPermissao(this.$permissao.EMITIR_BOLETO)
    },
    showEditarDae (processo) {
      return (this.processoIsAguardandoBoleto(processo) || this.processoIsBoletoVencido(processo)) && this.hasPermissao(this.$permissao.EMITIR_BOLETO)
    },
    showDae (processo) {
      return this.hasPermissao(this.$permissao.VIEW_DAES)
    },
    labelShowDae () {
      return 'Gerenciar Boleto'
    },
    showEmitirTitulo (processo) {
      return this.processoIsAguardandoEmissaoTitulo(processo) && this.hasPermissao(this.$permissao.EMITIR_TITULO) && (processo.idUsuario === this.usuario.id || (processo.idUsuario === null && !this.isTecnicoDatgl()))
    },
    showEmitirCertidao (processo) {
      return this.processoIsAguardandoEmissaoCertidao(processo) && this.hasPermissao(this.$permissao.EMITIR_CERTIDAO)
    },
    showContinuarEmitirTitulo (processo) {
      return this.processoIsEmEmissaoTitulo(processo) && this.hasPermissao(this.$permissao.CONTINUAR_EMISSAO_TITULO) && processo.idUsuario === this.usuario.id && this.usuario.perfilSelecionado.codigo.includes(processo.codigoPerfil)
    },
    showContinuarCertidao (processo) {
      return this.processoIsEmEmissaoCertidao(processo) && this.hasPermissao(this.$permissao.CONTINUAR_EMISSAO_CERTIDAO) && processo.idUsuario === this.usuario.id && this.usuario.perfilSelecionado.codigo.includes(processo.codigoPerfil)
    },
    showConferirTitulo (processo) {
      return this.processoIsAguardandoConferenciaTitulo(processo) && (processo.idUsuario === this.usuario.id || (!processo.idUsuario && !this.isTecnicoDatgl()))
    },
    showConferirCertidao (processo) {
      return this.processoIsAguardandoConferenciaCertidao(processo) && this.hasPermissao(this.$permissao.CONFERIR_CERTIDAO)
    },
    showAvocarProcesso (processo) {
      return this.hasPermissao(this.$permissao.AVOCAR_PROCESSO)
    },
    showArquivarProcesso (processo) {
      return this.hasPermissao(this.$permissao.ARQUIVAR_PROCESSO)
    },
    showAtualizacaoBase (processo) {
      return this.hasPermissao(this.$permissao.VALIDAR_ATUALIZACAO_BASE)
    },
    showRevisarAnalise (processo) {
      return this.hasPermissao(this.$permissao.REVISAR_ANALISE) &&
        this.statusEmRevisao.includes(processo.codigoStatus)
    },
    showRevisarPortaria (processo) {
      return this.hasPermissao(this.$permissao.REVISAR_PORTARIA) && processo.codigoStatus === statusProcesso.EM_REVISAO_ANALISE_PORTARIA
    },
    showContinuarAnalise (processo) {
      const podeContinuarAnalise = (this.usuario.perfilSelecionado.codigo.includes(processo.codigoPerfil) &&
        this.hasPermissao(this.$permissao.ANALISAR_PROCESSO) &&
        processo.idUsuario === this.usuario.id &&
        !this.showRevisarAnalise(processo) &&
        processo.codigoStatus !== statusProcesso.EM_EMISSAO_CERTIDAO &&
        processo.codigoStatus !== statusProcesso.EM_EMISSAO_OFICIO &&
        processo.codigoStatus !== statusProcesso.EM_ELABORACAO_ERRATA_TITULO &&
        processo.codigoStatus !== statusProcesso.EM_CALCULO_VTN &&
        processo.codigoStatus !== statusProcesso.EM_CONFERENCIA_TITULO &&
        processo.codigoStatus !== statusProcesso.EM_EMISSAO_TITULO) ||
        (this.processoIsEmAnaliseOs(processo) &&
        processo.codigoStatus !== statusProcesso.EM_REVISAO)
      return podeContinuarAnalise && !processo.retificacao
    },
    showContinuarAnaliseTecnico (processo) {
      return processo.codigoStatus === statusProcesso.EM_ANALISE
    },
    showContinuarEmissaoCertidaoArea (processo) {
      return false
    },
    showResponderInformacoes (processo) {
      return processo.status.toUpperCase() === statusProcesso.PENDENTE
    },
    showRetificarProcessso (processo) {
      if (this.isAnalistaOuGestaoSicarf() && this.filtro.caixa === 'CAIXA_RETIFICACAO') {
        return processo.tipoCodigo === 'REURB_INDIVIDUAL'
      }
      return this.hasPermissao(this.$permissao.RETIFICAR_PROCESSO) || processo.status === 'EM_RETIFICACAO_EM_ANALISE'
    },
    showVisualizarCertidao (processo) {
      return processo.tipoCodigo === 'CERTIDAO_TITULO'
    },
    showVisualizarTitulo (processo) {
      return processo.tipoCodigo !== 'CERTIDAO_TITULO' && processo.tipoCodigo !== 'CANCELAMENTO_CLAUSULA_RESOLUTIVA'
    },
    showVisualizarRetificacaoTitulo (processo) {
      return [statusProcesso.AGUARDANDO_ASSINATURA_ERRATA_TITULO, statusProcesso.AGUARDANDO_IMPRESSAO_ERRATA_TITULO, statusProcesso.TITULO_COM_ERRATA].includes(processo.codigoStatus)
    },
    showVisualizarOficio (processo) {
      return processo.tipoCodigo === 'CANCELAMENTO_CLAUSULA_RESOLUTIVA'
    },
    showArquivarAssinatura (processo) {
      if (processo.codigoStatus === statusProcesso.AGUARDANDO_ASSINATURA_ERRATA_TITULO) {
        return false
      }
      return this.usuario.perfilSelecionado.codigo.includes('PRESIDENTE_PRESIDENCIA')
    },
    showRetornarSetorAssinatura (processo) {
      return this.usuario.perfilSelecionado.codigo.includes('PRESIDENTE_PRESIDENCIA')
    },
    showEdital (processo) {
      return this.hasPermissao(this.$permissao.CADASTRAR_EDITAL) && processo.tipoCodigo === 'PERMUTA'
    },
    showUploadGuiaTransferencia (processo) {
      return false
    },
    //! Não encontrado
    showUploadTermoResgate (processo) {
      return this.hasPermissao(this.$permissao.UPLOAD_TERMOS)
    },
    //! Não encontrado
    showUploadContrato (processo) {
      return this.hasPermissao(this.$permissao.UPLOAD_TERMOS)
    },
    showUploadRecebimento (processo) {
      return this.hasPermissao(this.$permissao.UPLOAD_TERMOS)
    },
    showGerarCustas (processo) {
      return this.hasPermissao(this.$permissao.GERAR_CUSTA) && processo.codigoStatus === statusProcesso.AGUARDANDO_CALCULO_CUSTAS
    },
    showAssinarTitulo (processo) {
      return this.hasPermissao(this.$permissao.ASSINAR_TITULO)
    },
    showAssinarTodosTitulos (processo) {
      return this.hasPermissao(this.$permissao.ASSINAR_TODOS_TITULOS)
    },
    showEditarOs (processo) {
      return this.hasPermissao(this.$permissao.VIEW_ORDEM_SERVICO)
    },
    showDownloadOs (processo) {
      return this.hasPermissao(this.$permissao.VIEW_ORDEM_SERVICO)
    },
    showRetornarSetor (processo) {
      return false
    },
    showSolicitarRetificacao (processo) {
      return this.hasPermissao(this.$permissao.SOLICITAR_RETIFICACAO) && (
        this.usuario.perfilSelecionado.setor.codigo === setores.GPA ||
        this.usuario.perfilSelecionado.setor.codigo === setores.CAF ||
        this.usuario.perfilSelecionado.setor.codigo === setores.GCQ) && !processo.retificacao
    },
    showToltip (processo, codigo) {
      return !((!processo.podeAnalisar && codigo !== statusProcesso.VALIDAR) && (codigo === statusProcesso.ANALISAR_PROCESSO || codigo === statusProcesso.CONTINUAR_ANALISE || codigo === statusProcesso.VALIDAR))
    },
    textToltip (processo) {
      return !processo.podeAnalisar ? 'Você não tem permissão para analisar esse processo' : ''
    },
    showVisualizarInformacoes (item) {
      return item.status === 'RESPONDIDA'
    },
    showColunaDias () {
      return false
    },
    isTramitarPublicacaoPortaria (item) {
      return false
    },
    isTramitarAtualizarBase (processo) {
      return false
    },
    showRevisarValidacaoProcesso () {
      return false
    },
    showCadastrarDadosCustas (processo) {
      return false
    },
    processoCadastrandoDadosCustas () {
      return false
    },
    showCancelarRetificacaoProcessso (processo) {
      return false
    },
    processoIsEmPublicacao (processo) {
      return processo.codigoStatus === statusProcesso.EM_PUBLICACAO_PORTARIA
    },
    showContinuarPublicarPortaria (processo) {
      return this.processoIsEmPublicacao(processo) && this.hasPermissao(this.$permissao.PUBLICAR_PORTARIA)
    },
    showEmitirOficio (processo) {
      return processo.codigoStatus === statusProcesso.AGUARDANDO_EMISSAO_OFICIO
    },
    showRevisarOficio (processo) {
      return processo.codigoStatus === statusProcesso.EM_REVISAO_OFICIO
    },
    showContinuarEmissaoOficio (processo) {
      return processo.codigoStatus === statusProcesso.EM_EMISSAO_OFICIO
    },
    showCalcularVtnAp (processo) {
      return false
    },
    showCalcularVtnMa (processo) {
      return processo.codigoStatus === statusProcesso.AGUARDANDO_CALCULO_VTN
    },
    showContinuarCalcularVtnMa (processo) {
      return processo.codigoStatus === statusProcesso.EM_CALCULO_VTN
    },
    showContinuarCalcularVtnAp (processo) {
      return false
    },
    showRevisarVtn (processo) {
      return false
    },
    showCalcularVtnRr (processo) {
      return false
    },
    showAguardandoDecisao (processo) {
      return processo.codigoStatus === statusProcesso.AGUARDANDO_DECISAO
    },
    showEmDecisao (processo) {
      return processo.codigoStatus === statusProcesso.EM_DECISAO
    },
    showContinuarCalcularVtnRR (processo) {
      return false
    },
    showIniciarValidacaoManual (processo) {
      return false
    },
    showImprimirTitulo (processo) {
      if (this.isAnalistaOuGestaoSicarf()) {
        return processo.tipoCodigo === 'REURB_INDIVIDUAL' && processo.codigoStatus === statusProcesso.AGUARDANDO_IMPRESSAO_TITULO && this.hasPermissao(this.$permissao.VIEW_ACAO_IMPRESSAO_TITULO_E_DOCUMENTOS)
      } else {
        return processo.tipoCodigo !== 'REURB_INDIVIDUAL' && processo.codigoStatus === statusProcesso.AGUARDANDO_IMPRESSAO_TITULO && this.hasPermissao(this.$permissao.VIEW_ACAO_IMPRESSAO_TITULO_E_DOCUMENTOS)
      }
    },
    showImprimirDocumentos (processo) {
      if (this.isAnalistaOuGestaoSicarf()) {
        return processo.tipoCodigo === 'REURB_INDIVIDUAL' && processo.codigoStatus === statusProcesso.AGUARDANDO_IMPRESSAO_TITULO && this.hasPermissao(this.$permissao.VIEW_ACAO_IMPRESSAO_TITULO_E_DOCUMENTOS)
      } else {
        return processo.tipoCodigo !== 'REURB_INDIVIDUAL' && processo.codigoStatus === statusProcesso.AGUARDANDO_IMPRESSAO_TITULO && this.hasPermissao(this.$permissao.VIEW_ACAO_IMPRESSAO_TITULO_E_DOCUMENTOS)
      }
    },
    showImprimirRetificacaoTitulo (processo) {
      return processo.codigoStatus === statusProcesso.AGUARDANDO_IMPRESSAO_ERRATA_TITULO && this.isPerfilDatglPerfilSelecionado()
    },
    showRetornarSetorImpressao (processo) {
      if (this.isAnalistaOuGestaoSicarf()) {
        return processo.tipoCodigo === 'REURB_INDIVIDUAL' && processo.codigoStatus === statusProcesso.AGUARDANDO_IMPRESSAO_TITULO && this.hasPermissao(this.$permissao.VIEW_ACAO_IMPRESSAO_TITULO_E_DOCUMENTOS)
      } else {
        return processo.tipoCodigo !== 'REURB_INDIVIDUAL' && processo.codigoStatus === statusProcesso.AGUARDANDO_IMPRESSAO_TITULO && this.hasPermissao(this.$permissao.VIEW_ACAO_IMPRESSAO_TITULO_E_DOCUMENTOS)
      }
    },
    showRetornarArquivarImpressao (processo) {
      return processo.codigoStatus === statusProcesso.AGUARDANDO_IMPRESSAO_TITULO &&
        this.hasPermissao(this.$permissao.VIEW_ACAO_IMPRESSAO_TITULO_E_DOCUMENTOS) &&
        processo.tipoCodigo === 'REURB_INDIVIDUAL'
    },
    showEncerrarRetificao (processo) {
      return processo.retificacao === true
    },
    showFecharPendencia (processo) {
      return processo.retificacao === false
    },
    showRegerarAnaliseAutomatizada (processo) {
      return processo.status !== 'PENDENTE'
    },
    showStatusAnaliseAutomatizada (processo) {
      return processo.jobId && processo.status !== 'MANUAL' && processo.status !== 'PENDENTE'
    },
    showSolicitarRetificacaoTitulo (processo) {
      if (this.isAnalistaOuGestaoSicarf()) {
        return [statusProcesso.FINALIZADO, statusProcesso.TITULO_COM_ERRATA].includes(processo.codigoStatus) && !processo?.tipoCodigo?.includes('REURB') && !processo?.tipoCodigo?.includes('TT')
      }
      return false
    },
    showCancelarTitulo (processo) {
      if (this.isAnalistaOuGestaoSicarf()) {
        return ![statusProcesso.TITULO_CANCELADO, statusProcesso.AGUARDANDO_ASSINATURA_ERRATA_TITULO, statusProcesso.AGUARDANDO_ELABORACAO_ERRATA_TITULO, statusProcesso.EM_ELABORACAO_ERRATA_TITULO
        ].includes(processo.codigoStatus)
      }
    },
    showRetificarTituloCaixaEntrada (processo) {
      if (processo.idUsuario) {
        return processo.codigoStatus === statusProcesso.AGUARDANDO_ELABORACAO_ERRATA_TITULO && this.isPerfilDatglPerfilSelecionado() && this.usuario.id === processo.idUsuario
      } else {
        return processo.codigoStatus === statusProcesso.AGUARDANDO_ELABORACAO_ERRATA_TITULO && this.isPerfilChefeSetorDatgl()
      }
    },
    showRetificarTituloCaixaAnalise (processo) {
      return processo.codigoStatus === statusProcesso.EM_ELABORACAO_ERRATA_TITULO && this.usuario.id === processo.idUsuario
    },
    showAcusarEntregaUsuario (processo) {
      const usuarioDonoProcesso = processo.codigoPerfil.includes(this.usuario.perfilSelecionado.codigo.split('_')[0]) &&
        processo.idUsuario === this.usuario.id
      return usuarioDonoProcesso || (this.usuario.perfilSelecionado.codigo.split('_')[0] !== 'ASSESSOR' && !processo.idUsuario)
    },
    showAcusarEntregaTitulo (processo) {
      return false
    },
    showAcaoSuspender (processo) {
      return false
    },
    showAcaoCancelarSuspensao (processo) {
      return false
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/screens/analise/listagem/ma/BaseFiltro.vue